import gust from '../../plugin/axios'
const darkMode = {
 state:{
    dark: false
  },
  getters:{
    dark: (state) => state.dark,
  },
 mutations:{
    SET_DARK(state, bool){
      state.dark = bool;
    }
  }

}
export default darkMode
